import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Colors, BrandingColors } from "design-system";
import { StAnchor } from "core/app/presenter/sideNav/SideNavStyles";

const StStaticContainer = styled("div")`
  padding: 0 18px;
  position: relative;

  &:hover {
    background: ${BrandingColors.Hover};
  }
`;

// Extends StAnchor with static link visual treatment
const StStaticAnchor = styled(StAnchor)`
  color: ${Colors.White} !important;
  opacity: 0.5;
  margin: 9px 0;
  transition: opacity 150ms ease;

  &:hover {
    opacity: 1;
  }
`;

const StaticLinks = React.memo(({ title, url }) => (
  <StStaticContainer>
    <StStaticAnchor href={url} target="_blank" rel="noopener noreferrer">
      {title}
    </StStaticAnchor>
  </StStaticContainer>
));

StaticLinks.displayName = "StaticLinks";
StaticLinks.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default StaticLinks;
